import React from 'react';
import { TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';

const Tags = ({ subCategories, subCategoriesList, updateTemplateSubCategories }) => (
  <Autocomplete
    style={styles.categories}
    value={subCategories}
    onChange={(_, value) => {
      updateTemplateSubCategories(value);
    }}
    multiple
    options={subCategoriesList}
    getOptionLabel={({ _id: id, titleEn, titleFr }) => titleEn || titleFr || id || 'None'}
    renderInput={(params) => (
      <TextField
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...params}
        variant="outlined"
        label="Subcategories"
        placeholder="New subcategory"
      />
    )}
  />
);

const styles = {
  categories: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    width: 500,
  },
};

export default Tags;



// WEBPACK FOOTER //
// ./src/components/templates-manager/tags/tags.js